export default __webpack_public_path__ + "static/funnel-small-ad7a8ae4d3f8ebc3322515d05a4ae2d9.svg";